import React from 'react';

const StructuredData: React.FC = () => {
    const organizationStructural = {
        '@context': 'http://schema.org/',
        '@type': 'Organization',
        'url': 'https://www.skapiec.pl/',
        'logo': 'https://ocdn.eu/skapiec/logo-blue-background.svg',
        'sameAs': [
            'https://www.instagram.com/skapiec_pl/',
            'https://www.facebook.com/Skapiec'
        ],
        'contactPoint': {
            '@context': 'http://schema.org/',
            '@type': 'ContactPoint',
            'telephone': '12-26-00-200',
            'contactType': 'customer service',
            'areaServed': 'PL',
            'availableLanguage': 'Polish'
        }
    };

    return (
        <>
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationStructural) }}
            />
        </>
    );
};

export default StructuredData;
